// extracted by mini-css-extract-plugin
module.exports = {"container":"_3offhZOQTfPXigXvy4Y9Ep","icon":"_1ac4d0rY1ymGF1Pio0pRDD","content":"_3waQ2HXMKQpTtRpQBGUHaq","title":"_2dQge9HkP0Njj0WV24CnhQ","address":"_32wr8XYSC2L8OU4KnV0RrB"};